import { useMemo } from 'react';
import I18n from 'I18n';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import ChangePlaylistThumbnailButton from './ChangePlaylistThumbnailButton';
import PlaylistItemsSearch from './PlaylistItemsSearch';
import { CardMenuOptions } from '../../cardMenu/components/CardMenu';
import { usePlaylistItemCardModels } from '../savedItemsHooks';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { jsx as _jsx } from "react/jsx-runtime";
const PLAYLIST_ITEMS_HEIGHT = 250;
const getCardModelKey = (id, type) => `${readUnhandledEnumCase(type)}:${id}`;
const ChangeThumbnailItemsList = ({
  playlist,
  items,
  renderList = content => /*#__PURE__*/_jsx(ScrollContainer, {
    maxHeight: PLAYLIST_ITEMS_HEIGHT,
    children: /*#__PURE__*/_jsx(CardMenuOptions, {
      "aria-label": I18n.text('academyCommon.cardMenu.playlistItems'),
      children: content
    })
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(SideNavItem, {
    title: content
  }, key),
  onItemClick
}) => {
  const {
    cardModels,
    cardModelsLoading
  } = usePlaylistItemCardModels({
    playlistItems: playlist.items,
    skipProgress: true
  });
  const cardModelMap = useMemo(() => {
    const map = new Map();
    if (!cardModels) return map;
    for (const model of cardModels) {
      map.set(getCardModelKey(model.id, model.type), model);
    }
    return map;
  }, [cardModels]);
  return renderList(items && items.map(item => {
    const {
      itemId
    } = item;
    const cardModel = cardModelMap.get(getCardModelKey(itemId, item.type));
    if (!cardModel) return null;
    return renderRow( /*#__PURE__*/_jsx(ChangePlaylistThumbnailButton, {
      block: true,
      loading: cardModelsLoading,
      name: item.name,
      onClick: () => {
        if (onItemClick) {
          onItemClick(item);
        }
      },
      playlistId: playlist.id,
      previewThumbnailRectangleUrl: cardModel.previewThumbnailRectangleUrl,
      previewThumbnailSquareUrl: cardModel.previewThumbnailSquareUrl
    }), `playlist_${playlist.id}_item_${itemId}`);
  }).filter(Boolean));
};
const ChangePlaylistThumbnail = ({
  playlistId,
  renderList,
  renderRow,
  onItemClick
}) => {
  return /*#__PURE__*/_jsx(PlaylistItemsSearch, {
    playlistId: playlistId,
    render: (playlist, items) => playlist && items && /*#__PURE__*/_jsx(ChangeThumbnailItemsList, {
      items: items,
      onItemClick: onItemClick,
      playlist: playlist,
      renderList: renderList,
      renderRow: renderRow
    })
  });
};
export default ChangePlaylistThumbnail;